import { useStytchWorkspaces } from '@/hooks/useStytchWorkspaces'
import {
	isWorkspaceSelectorOpen,
	setIsCreateWorkspaceDialogOpen,
	setIsWorkspaceSelectorOpen,
} from '@/redux/store/slices/ui/uiSlice'
import { Dialog } from '@mui/material'
import { useAppDispatch, useAppSelector } from '@redux/hooks/useAppState'
import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { WorkspaceList } from '../WorkspaceList'

import type { FC } from 'react'

export const WorkspaceSelector: FC = () => {
	const { workspaces } = useStytchWorkspaces()
	const isOpen = useAppSelector(isWorkspaceSelectorOpen)
	const dispatch = useAppDispatch()
	const location = useLocation()
	const navigate = useNavigate()

	const onClose = useCallback(() => {
		dispatch(setIsWorkspaceSelectorOpen(false))
	}, [dispatch])

	const onAddNew = () => {
		dispatch(setIsWorkspaceSelectorOpen(false))
		dispatch(setIsCreateWorkspaceDialogOpen(true))
	}

	const onWorkspaceSelect = useCallback((workspace?: any) => {
		dispatch(setIsWorkspaceSelectorOpen(false))

		// If we're on an admin route, navigate to the workspace grids
		if (location.pathname.startsWith('/admin')) {
			navigate(`/${workspace.organization_slug}/grids`)
		}
	}, [dispatch, location.pathname, navigate])

	return (
		<Dialog onClose={onClose} open={isOpen} fullWidth>
			<WorkspaceList workspaces={workspaces} onAddNew={onAddNew} onWorkspaceSelect={onWorkspaceSelect} />
		</Dialog>
	)
}
